import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Questionnaire from '../questionnaire/questionnaire';
import { useInsightsV2Hook } from './useInsightsV2Hook';
import styles from './insightsV2.style';
import MilestoneMapper from '../milestone-mapper/milestone-mapper';
import UnleashProvider from '../../../../core/unleash/unleashProvider';
import { UnleashService } from '../../../../services';

const InsightsV2 = (props) => {
  const { questions, getSectionQuestions, getStartIndex, isLoading } = useInsightsV2Hook(props);
  const { classes } = props;

  return (
    <Box className={classes.root} data-testid="my-profile-container">
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <Box className={classes.questionnaireSection}>
            {getSectionQuestions(questions).map(({ section, questions: sectionQuestions }) => (
              <React.Fragment key={section}>
                <Questionnaire
                  questions={sectionQuestions}
                  title={section}
                  type={section.toLowerCase()}
                  startIndex={getStartIndex(questions, section)}
                />
              </React.Fragment>
            ))}
          </Box>

          <Box className={classes.milestoneSection}>
            <UnleashProvider flagName={UnleashService.FLAGS.LEARNER_MILESTONE_MAPPER}>
              <MilestoneMapper user={props.user} />
            </UnleashProvider>
          </Box>
        </>
      )}
    </Box>
  );
};

export default withStyles(styles)(InsightsV2);
